import { SelectProps } from "antd";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import { CapaOrientacaoEnum } from "features/relatorios/prestacao-contas/typings";

export interface SelectOrientacaoCapaRelatorioProps<T = any>
  extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectOrientacaoCapaRelatorio({
  value,
  ...rest
}: SelectOrientacaoCapaRelatorioProps) {
  const options = [
    {
      value: CapaOrientacaoEnum.Retrato,
      label: "Retrato",
    },
    {
      value: CapaOrientacaoEnum.Paisagem,
      label: "Paisagem",
    },
  ];

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      defaultValue={CapaOrientacaoEnum.Retrato}
      options={options}
      {...rest}
    />
  );
}

export default SelectOrientacaoCapaRelatorio;
